export default function (slotScene, bonusScene, superbonusScene, parent, $ticker) {
    const space = parent.child( "superbonus" );
    
    if (!superbonusScene || !bonusScene) {
        return {
            space
        };
    }
    
    if ( superbonusScene.update )
    {
        $ticker.subscribe(dt => {
            superbonusScene.update(dt);
        });
    }
    
    
    space.s("start").subscribe (stageMath => {
        // тут нужно показать супербонусную сцену и передать ей stageMath
    });
    
    
    space.s("end").subscribe (stageMath => {
        // тут нужно спрятать супербонусную сцену и показать слотовую
        superbonusScene.visible = false;
        superbonusScene.pause();
        
        slotScene.resume();
        slotScene.visible = true;
    });
    
    const $beginComplete = space.s( "beginComplete" );
    

    space.s("begin").subscribe (stageMath => {

    });
    
    
    const $endingComplete = space.s( "endingComplete" );
    
    // показ таблички после бонуса (сцена сама разберется что ей надо в этих данных)
    space.s( "ending" ).subscribe( ({ math, bet }) => {
        superbonusScene.showFinishTable(
            math,
            bet,
            () => $endingComplete.next()
        );
    });
    
    // способ передачи в движок варианта выбора, который был сделал тычком по элементу сцены
    // если игрок выбирал через F-клавишу то это обрабатывается в движке
    const $superbonusSelection = space.s( "selection" );
    superbonusScene.onUserSelect = variant => {$superbonusSelection.next(variant);};
    
    // пользователь сделал выбор - дальше идет длительная сетевая операция
    // выборы пока делать нельзя
    // (что именно выбрал игрок отобразится в методе, ответственом за показ данных от сервера)
    space.s("selectionHasMade").subscribe(variant => {
        superbonusScene.selectionHasMade(variant);
    });
    
    // выбор (не важно каким путем он сделан) блокирует сцену пока не покажестя исход шага супербонуса
    space.s( "selection" ).to( space.s( "selectionHasMade" ) );
    
    
    const $displayComplete = space.s( "displayComplete" )
        .description('superbonus step iteration has been shown');
    
    // получены данные от сервера с исходом супербонуса и выбором которй сделал игрок
    space.s("showResult").subscribe(bonusData => {
    
        // это еще и вход в сцену :(
        bonusScene.visible = false;
        
        superbonusScene.visible = true;
    
        superbonusScene.showResult(bonusData, () => {
            $displayComplete.next();
        });
    });
    
    return {
        space
    };
}


// WEBPACK FOOTER //
// ./src/library/superbonus_view.es6